/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_mobile_analytics_app_id": "4338ad7e3c0c42eb98fc6bb2ffad9f84",
    "aws_mobile_analytics_app_region": "us-east-1",
    "Analytics": {
        "AWSPinpoint": {
            "appId": "4338ad7e3c0c42eb98fc6bb2ffad9f84",
            "region": "us-east-1"
        }
    },
    "aws_cloud_logic_custom": [
        {
            "name": "gnjAmplifyStripeWebhooks",
            "endpoint": "https://cu9xrrwp5h.execute-api.us-east-1.amazonaws.com/production",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://qxg7xs7mvvfebjgj6zwwdrwdnu.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "us-east-1:0573d83d-ed84-4c85-b3aa-31854936a75a",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_MjKPaSZT4",
    "aws_user_pools_web_client_id": "7k0dmghplva0959erm7ovno27l",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "gnj-amplify-production",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
